import * as React from 'react';
import { Dispatch, SetStateAction } from 'react';
import Select, { components } from 'react-select';
import makeAnimated from 'react-select/animated';

export type SelectorOption = {
  value: string;
  label: string;
};
type SelectorProps = {
  defaultValue?: SelectorOption[];
  onChange?:
    | Dispatch<SetStateAction<{ value: string; label: string }[]>>
    | Dispatch<SetStateAction<{ value: string; label: string }>>;
  options?: SelectorOption[];
  id?: string;
  isMulti?: boolean;
  placeholder?: string;
  ariaLabel?: string;
  value?: SelectorOption[] | SelectorOption;
  formatOptionLabel?: (option: SelectorOption) => React.ReactElement;
  disabled?: boolean;
};

const CustomMultiValue = (props) => <components.MultiValue {...props}>{props?.data?.label}</components.MultiValue>;

export const Selector = ({
  defaultValue,
  value,
  onChange,
  options,
  id,
  isMulti,
  placeholder,
  ariaLabel,
  formatOptionLabel,
  disabled,
}: SelectorProps) => {
  const animatedComponents = makeAnimated({ MultiValue: CustomMultiValue });
  return (
    <Select
      aria-label={ariaLabel}
      id={id}
      name={id}
      isMulti={isMulti}
      components={animatedComponents}
      defaultValue={defaultValue}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      value={value}
      formatOptionLabel={formatOptionLabel}
      isDisabled={disabled}
    />
  );
};
